export function install() {
    console.log('[CONVERSATION-SIDEBAR-DELETE] Plugin initialized');
}

export default { install };
